import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2'; 
import { NzModalService } from 'ng-zorro-antd'; 
import { FcinputComponent } from '../fcinput';
import { FcmodallistdataComponent } from './fcmodallistdata.component';
import { GRIDOPTIONS } from '../business/fclistdata.business';
/**
 * fc-modallistdataæ°æ®åè¡¨æ¨¡ææ¡
 * 
 * åè¡¨æ¨¡ææ¡ç»ä»¶ã
 * 
 * ç¹å»æé®å¼¹åºåè¡¨æ¨¡ææ¡ã
 * 
 * äºä»¶
 * 
 * 1.æåäºä»¶ï¼success
 * 
 * 2.åæ¶äºä»¶ï¼cancle
 * 
 */
@Component({
    selector: 'fc-modallist',
    template: ``,
    styles: [`  
      :host ::ng-deep .fc-modallist .ant-modal {
        height:70%;
      }
      :host ::ng-deep .fc-modallist .ant-modal-content{
        width:100%;
        height:100%;
      }
      :host ::ng-deep .fc-modallist .ant-modal-body{
        width: 100%;
        height: calc(100% - 90px);
      }
    
    `]
})
export class FcmodallistComponent extends FcinputComponent {
    // æ°æ®åå®¹ç¬¦åå¨æäºèå´çæ¶åæ¾ç¤ºæäºæä½æé®ï¼ä¸ç¬¦ååä¸æ¾ç¤ºï¼
        // å·ä½å®æ½æ¹æ¡ä¸ºå¨ç»ä»¶fclistdataç»ä»¶ä¸­å¢å æ°å±æ§ï¼
        // fcViewActionStrategy="[{FIELDCODE:'STATUS',FIELDVALUE:'èµ·è',BUTTONS:['listAdd','listDelete','listView',]}]"
       
        @Input()
        fcViewActionStrategy:string="[{FIELDCODE:'STATUS',FIELDVALUE:'èµ·è',BUTTONS:['listAdd','listDelete','listView',]}]";
        
     /**èªå®ä¹åé¡µæ¨¡å¼*/
    @Input()
    fcCustomPagination:boolean;
     /**æ é¢*/
    @Input()
    fcTitle: string;
    @Input()
    fcRowData: any[];
    private _option: GRIDOPTIONS;
    _data: any[];
    @Input()
    fcCondition: string;
     /**åé¡µå¤§å°*/
    @Input()
    fcPageSize: number;
     /**åé¡µå¤§å°*/
    @Input()
    fcPageNum: number;
     /**æå®æ¯é¡µå¯ä»¥æ¾ç¤ºå¤å°æ¡*/
    @Input()
    fcPageSizeSelectorValues: number[];
     /**è¡é»è®¤éä¸­*/
    @Input()
    fcDeafultSelected: any[];
    /**éä¸­*/
    @Input()
    fcSelectObjs:any[];
    /*  */
    constructor(public provider: ProvidersService, public modalService: NzModalService) {
        super(provider, 'fc-modallist');
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
        if (this.fcTitle === undefined) {
            throw new Error("å¼¹çªçfcTitleåæ°æªä¼ å¥");
        }
        if (this.fcCondition === undefined) {
            this.fcCondition = "{}";
        }
        if (this.fcType === undefined || this.fcType === 'single') {
            this._option = {
                 /**ç®è¤é»è®¤ä¸ºbootstrapé£æ ¼*/
                fcClass: 'ag-theme-blue',
                fcHeight: 450,
                fcRowHeight:22,
                fcPaginationPageSize: 20,
                fcEnableSearch: true,
                 /**æ¯å¦å¯ç¨æåº*/
                fcEnableSorting: true,
                 /**æ¯å¦å¯ç¨è¿æ»¤*/
                fcEnableFilter: true,
                 /**æ¯å¦èªå¨è®¾ç½®è¡¨å¤´å¤§å°*/
                fcEnableColResize: true,
                 /**æ¯å¦æ¾ç¤ºå·¥å·æ */
                fcShowToolPanel: false,
                  /**æ¯å¦åé¡µ*/
                fcPagination: true,
                 /**æ¯å¦å¯ç¨ç¶ææ */
                fcEnableStatusBar: false,
                 /**æ¯å¦å¯ç¨åºåéä¸­*/
                fcEnableRangeSelection: true,
                 /**éä¸­æ¹å¼*/
                fcRowSelection: 'single',
                 /**æ¯å¦å¯ç¨æä½å*/
                fcEnableAction: false,
                 /**éä¸­æcheckbox*/
                fcCheckboxSelection: false,
                 /**æ¯å¦å¯ç¨ç¼è¾*/
                fcEnableEdit: false
            };
        } else {
            this._option = {
                 /**ç®è¤é»è®¤ä¸ºbootstrapé£æ ¼*/
                fcClass: 'ag-theme-blue',
                fcHeight: 450,
                fcRowHeight:22,
                fcPaginationPageSize: 20,
                fcEnableSearch: true,
                 /**æ¯å¦å¯ç¨æåº*/
                fcEnableSorting: true,
                 /**æ¯å¦å¯ç¨è¿æ»¤*/
                fcEnableFilter: true,
                 /**æ¯å¦èªå¨è®¾ç½®è¡¨å¤´å¤§å°*/
                fcEnableColResize: true,
                 /**æ¯å¦æ¾ç¤ºå·¥å·æ */
                fcShowToolPanel: false,
                  /**æ¯å¦åé¡µ*/
                fcPagination: true,
                 /**æ¯å¦å¯ç¨ç¶ææ */
                fcEnableStatusBar: false,
                 /**æ¯å¦å¯ç¨åºåéä¸­*/
                fcEnableRangeSelection: true,
                 /**éä¸­æ¹å¼*/
                fcRowSelection: this.fcType,
                 /**æ¯å¦å¯ç¨æä½å*/
                fcEnableAction: false,
                 /**éä¸­æcheckbox*/
                fcCheckboxSelection: true,
                 /**æ¯å¦å¯ç¨ç¼è¾*/
                fcEnableEdit: false
            };
        }
    }
    showModal(): any {
        let _this1 = this;
        let option: FcmodalOption = {
            options: this._option,
            rowData: this.fcRowData,
            appId: this.fcAppid,
            condition: this.fcCondition,
            pageSize: this.fcPageSize,
            pageNum: this.fcPageNum,
            deafultSelected: this.fcDeafultSelected,
            selectObjs: this.fcSelectObjs,
            fcCustomPagination:this.fcCustomPagination,
            viewActionStrategy:this.fcViewActionStrategy
        };
        const subscription = this.modalService.create({
            nzTitle: this.fcTitle,
            nzContent: FcmodallistdataComponent,
            nzWrapClassName: "fc-modallist",
            nzWidth: "70%",
            nzStyle:{
                height:'70%'
            },
            nzOnOk(componentInterface) {
                //ç¹å»OKæé®æ¥åå¼¹çªåå®¹ä½çåæ°ï¼ä¼ ç»éå¼¹çªåå®¹é¡µé¢componentInterface
                _this1.event("success",  componentInterface.fcSelectObjs );
            },
            nzOnCancel() {
                _this1.event( "cancle",  [] );
            },
             /** nzFooter: true,*/
            nzComponentParams: {
                //éå¼¹çªé¡µé¢ä¼ åå®¹ç»å¼¹çªåé¨
                options: option
            }
        });
        subscription.afterClose.subscribe(result => {
            if (result instanceof Array) {
                this._data = result;
            }
            if (this.fcType === 'single' && result&&result.length === 1) {
                let flag = true;
                let selectObjs = this.fcDeafultSelected;
                if (selectObjs && selectObjs.length > 0) {
                    let selectObj = selectObjs[0];
                    Object.keys(selectObj).forEach(key => {
                        if (!flag) {
                            return;
                        }
                        if (selectObj[key] !== undefined) {
                            flag = false;
                        }
                    })
                }
                if (flag) {
                    subscription.destroy('onOk');
                }
            }
        });
    }
}
export interface FcmodalOption {
    options: GRIDOPTIONS,
    rowData: any,
    appId: string,
    condition: string,
    pageSize: number,
    pageNum: number,
    selectObjs: any[]
    fcCustomPagination:boolean,
    deafultSelected:any[],
    viewActionStrategy,
    // æ°æ®åå®¹ç¬¦åå¨æäºèå´çæ¶åæ¾ç¤ºæäºæä½æé®ï¼ä¸ç¬¦ååä¸æ¾ç¤ºï¼
        // å·ä½å®æ½æ¹æ¡ä¸ºå¨ç»ä»¶fclistdataç»ä»¶ä¸­å¢å æ°å±æ§ï¼
        // fcViewActionStrategy="[{FIELDCODE:'STATUS',FIELDVALUE:'èµ·è',BUTTONS:['listAdd','listDelete','listView',]}]"
       
}